import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1920,260 L1920,372.941176 L1048.43294,372.941176 L558.494118,1660.69647 L451.990588,1658.32471 L244.743529,1031.04941 L0,1031.04941 L0,918.108235 L285.515294,918.108235 L339.162353,956.847059 L509.364706,1471.97176 L956.611765,296.367059 L1009.46824,260 L1920,260 Z M1786.01788,863.218824 L1865.86729,943.181176 L1585.66024,1223.16235 L1865.86729,1503.36941 L1786.01788,1583.10588 L1505.81082,1303.01176 L1225.82965,1583.10588 L1145.98024,1503.36941 L1426.07435,1223.16235 L1145.98024,943.181176 L1225.82965,863.218824 L1505.81082,1143.31294 L1786.01788,863.218824 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconEquationLine = /*#__PURE__*/function (_Component) {
  _inherits(IconEquationLine, _Component);

  var _super = _createSuper(IconEquationLine);

  function IconEquationLine() {
    _classCallCheck(this, IconEquationLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconEquationLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconEquation",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconEquationLine.displayName = "IconEquationLine";
  return IconEquationLine;
}(Component);

IconEquationLine.glyphName = 'equation';
IconEquationLine.variant = 'Line';
IconEquationLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconEquationLine;
export { IconEquationLine };